import {resolvePortLabels} from '@/utils/ports'
import {shortenizeFullName} from '@/utils/misc'
import moment from 'moment'
import {get} from 'lodash'
import store from '@/store'
import i18t from '@/lang'

function formatDate (dateStr, format) {
  let m = moment(dateStr).utc(true)
  if (!m.isValid()) {
    return null
  }
  return format !== undefined ? m.format(format) : m.toISOString()
}

// TODO: implement it
function getInitiatorName (userId) {
  const initiators = get(store.getters.user, ['roleUsers', 'INITIATORS'], [])
  return initiators.find(user => user.id === userId) || userId
}


class FlightOrderDisplay {
  id = null
  from = null
  to = null
  depPortId = null
  arrPortId = null
  depPortLabels = null
  arrPortLabels = null
  flightDateString = null
  flightDate
  initiator
  source
  searchString
  isCargo
  //
  orderData
  processData
  organization
  title
  //
  shortName
  birthDateStr = null
  //
  _flightOrder

  _createTitle () {
    let title = ''
    if (this.isCargo) {
      const { name, dimensions, packType, placeCount, weight } = this.orderData
      title = `${name} (x${placeCount}) ${packType}(${dimensions}, ${weight}kg)`
    } else {
      const { fullName, docNum } = this.orderData
      const shortName = shortenizeFullName(fullName)
      title = `${shortName}, ${docNum}`
    }
    this.title = title
  }

  getState () {
    return get(this, 'processData.orderStatus', 'noState')
  }

  getRoute () {
    const { code: depPortCode } = this.depPortLabels
    const { code: arrPortCode } = this.arrPortLabels
    return `${depPortCode} - ${arrPortCode}`
  }

  getErrorTitle () {
    const errors = this.errors || []
    return errors.map(code => i18t.t(`flight-orders.errors.${code}`)).join('\n')
  }

  static assign (flightOrderDisplayJson) {
    const flightOrderDisplay = Object.assign(new FlightOrderDisplay(), flightOrderDisplayJson)
    FlightOrderDisplay.resolveFlightPorts(flightOrderDisplay)
    return flightOrderDisplay
  }

  // TODO: check it and use
  static createByFlightOrder (flightOrder) {
    const depPortLabels = resolvePortLabels(flightOrder.depPortId)
    const arrPortLabels = resolvePortLabels(flightOrder.arrPortId)
    const from = get(depPortLabels, 'label', flightOrder.orderData.from)
    const to = get(arrPortLabels, 'label', flightOrder.orderData.to)

    const flightOrderDisplay = Object.assign(new FlightOrderDisplay(), {
      id: flightOrder.id,
      depPortId: flightOrder.depPortId,
      arrPortId: flightOrder.arrPortId,
      depPortLabels,
      arrPortLabels,
      from,
      to,
      flightDateString: formatDate(flightOrder.flightDate, 'YYYY-MM-DD'),
      flightDate: moment.utc(flightOrder.flightDate).toDate(),
      initiator: getInitiatorName(flightOrder.initiatorUserId),
      source: flightOrder.source,
      searchString: flightOrder.searchString,
      isCargo: flightOrder.cargo,
      //
      orderData: flightOrder.orderData,
      processData: flightOrder.processData,
      organization: flightOrder.orderData.organization,
      //
      '_flightOrder' : flightOrder
    })
    flightOrderDisplay._createTitle()

    if (!flightOrder.cargo) {
      flightOrderDisplay.shortName = shortenizeFullName(flightOrder.orderData.fullName)
      flightOrderDisplay.birthDateStr = formatDate(flightOrder.orderData.birthDate, 'YYYY-MM-DD')
    }

    return flightOrder
  }

  static resolveFlightPorts (flight) {
    flight.depPortLabels = resolvePortLabels(flight.depPortId)
    flight.arrPortLabels = resolvePortLabels(flight.arrPortId)
  }
}

export { FlightOrderDisplay }



// WEBPACK FOOTER //
// ./src/models/flighOrderDisplay.js